export default [
  {
    path: '/claim-reward-history',
    name: 'list-claim-reward-history',
    component: () => import('@/views/claimRewardHistory/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.claimRewardHistory',
      resource: 'claim-reward',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listClaimRewardHistory',
          active: true,
        },
      ],
    },
  },
]
